import * as React from 'react';

import {DUE_UNIT_DAYS_ID} from 'nutshell-core/date-time/delays';

import type {ClosedLeadTaskTemplateDueDateInput} from 'nutshell-graphql-types';

import {Checkbox} from '../fields/checkbox';

import {DueDateInputs} from './due-date-input';

import styles from '../date-time-picker.module.css';

type Props = {
    dueDate: ClosedLeadTaskTemplateDueDateInput | null | undefined;
    onDueDateChange: (arg1?: ClosedLeadTaskTemplateDueDateInput | null | undefined) => void;
};

export class DateTimePicker extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles.container}>
                <Checkbox
                    onChange={this.handleToggle}
                    label='Due Date'
                    checked={Boolean(this.props.dueDate)}
                />
                {this.props.dueDate ? (
                    <DueDateInputs
                        onDueDateChange={this.props.onDueDateChange}
                        dueDate={this.props.dueDate}
                    />
                ) : undefined}
            </div>
        );
    }

    handleToggle = () => {
        if (this.props.dueDate) {
            // Is we currently have a dueDate, set value to null
            this.props.onDueDateChange(null);
        } else {
            // Not currently active, so give a default value
            const defaultValue = {
                dueUnit: DUE_UNIT_DAYS_ID,
                dueTimespan: 1,
            } as const;

            this.props.onDueDateChange(defaultValue);
        }
    };
}
